/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { fg } from '@atlassian/jira-feature-gating';
import { ProjectStyle, type Project } from '@jira/platform__project-types/src/project-types.tsx';
import type { ProjectBean, ProjectSidebarNavInfo } from './types.tsx';

export const getStyle = (isSimplifiedProject: boolean): ProjectStyle =>
	isSimplifiedProject ? ProjectStyle.NEXT_GEN : ProjectStyle.CLASSIC;

const getProject = (project: ProjectBean): Project => ({
	avatarUrl: project.avatarUrls['48x48'],
	id: Number(project.id),
	isSimplified: project.simplified,
	key: project.key,
	name: project.name,
	style: getStyle(project.simplified),
	type: project.projectTypeKey,
	...(typeof project.isLiveTemplate === 'boolean' &&
		fg('jira_custom_templates_ux') && {
			isLiveTemplate: project.isLiveTemplate,
		}),
});

export const extractData = (data: ProjectSidebarNavInfo): Project | null => {
	const {
		projectType,
		jiraWorkManagementNavData,
		jiraSoftwareNavData,
		jiraServiceManagementNavData,
		jiraProductDiscoveryNavData,
	} = data || {};

	switch (projectType) {
		case 'jira_work_management':
			return jiraWorkManagementNavData?.project
				? getProject(jiraWorkManagementNavData.project)
				: null;
		case 'jira_software':
			return jiraSoftwareNavData?.project ? getProject(jiraSoftwareNavData.project) : null;
		case 'jira_service_management':
		case 'jira_customer_service':
			return jiraServiceManagementNavData?.project
				? getProject(jiraServiceManagementNavData.project)
				: null;
		case 'jira_product_discovery':
			return jiraProductDiscoveryNavData?.project
				? getProject(jiraProductDiscoveryNavData.project)
				: null;
		case null:
		default:
			return null;
	}
};
